import React from "react";
import { Navigate } from "react-router-dom";

const RoleProtected = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token || token === "undefined" || token === "null") {
    return <Navigate to="/auth/login" replace />;
  }
  return <>{children}</>;
};

export default RoleProtected;